module.exports = __webpack_public_path__ + "static/Background-gov-3.6186db9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-gov-3.jpg
// module id = 468
// module chunks = 53566712009029